/**
 * 滚动驱动文字逐行显现 + 背景渐变动态移动（颜色扫过效果）
 * 文字从左向右出现的同时，背景渐变也在移动，形成颜色变化
 */

function wheel_display_comparison() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  // --- 配置参数 -------------------------------------------------
  const SECTION_ID = 'wheel_display_comparison';
  const TRIGGER_DISTANCE = 66;          // 顶部距离阈值（px），到达时文字完全显示
  // 您指定的渐变色
  const TEXT_GRADIENT = 'linear-gradient(269deg, rgb(255, 255, 255) 32.4549%, rgb(0, 113, 227) 108.455%, rgb(0, 113, 227) 120.455%, rgb(255, 255, 255) 132.455%)';
  // -------------------------------------------------------------

  const section = document.getElementById(SECTION_ID);
  if (!section) return;

  // --- 1. 动态注入样式（mask控制显现 + 可移动的背景渐变）----------
  const styleEl = document.createElement('style');
  styleEl.textContent = `
    #${SECTION_ID} .font1,
    #${SECTION_ID} .font2 .font2_font,
    #${SECTION_ID} .font3 .font3_font1,
    #${SECTION_ID} .font3 .font3_font2 {
      position: relative;
      will-change: -webkit-mask, mask, background-position;
      transform: translateY(30px);
      transition: transform 0.7s ease-out;
      
      /* 文字渐变色（背景放大到200%宽度，以便移动） */
      background: ${TEXT_GRADIENT};
      background-size: 200% 100%;
      background-position: 0% 0%;
      -webkit-background-clip: text;
      background-clip: text;
      color: transparent;
      
      /* 默认完全透明（mask全透明） */
      -webkit-mask: linear-gradient(90deg, transparent 0%, transparent 100%);
      mask: linear-gradient(90deg, transparent 0%, transparent 100%);
    }

    /* 完全显示时去除 mask */
    #${SECTION_ID} .font1.fully-visible,
    #${SECTION_ID} .font2 .font2_font.fully-visible,
    #${SECTION_ID} .font3 .font3_font1.fully-visible,
    #${SECTION_ID} .font3 .font3_font2.fully-visible {
      -webkit-mask: none;
      mask: none;
      transform: translateY(0);
      /* 完全显示后背景位置归零（也可以保留最终状态） */
      background-position: 0% 0%;
    }
  `;
  document.head.appendChild(styleEl);

  // --- 2. 获取需要动画的元素（保持视觉顺序）----------------------
  const items = Array.from(document.querySelectorAll(`
    #${SECTION_ID} .font1,
    #${SECTION_ID} .font2 .font2_font,
    #${SECTION_ID} .font3 .font3_font1,
    #${SECTION_ID} .font3 .font3_font2
  `));
  const totalItems = items.length;
  if (totalItems === 0) return;

  // --- 3. 根据进度更新元素mask和背景位置 -------------------------
  function updateItemsByProgress(progress) {
    const fullItems = Math.floor(progress * totalItems);
    const partialProgress = (progress * totalItems) - fullItems;

    items.forEach((item, index) => {
      if (index < fullItems) {
        // 完全显示
        item.style.removeProperty('-webkit-mask');
        item.style.removeProperty('mask');
        item.classList.add('fully-visible');
        // 背景位置归零
        item.style.backgroundPosition = '0% 0%';
      } else if (index === fullItems) {
        // 当前正在逐渐显示的元素
        item.classList.remove('fully-visible');

        // 设置mask：从左向右逐渐显现
        const percent = partialProgress * 100;
        const maskValue = `linear-gradient(90deg, white 0%, white ${percent}%, transparent ${percent}%, transparent 100%)`;
        item.style.setProperty('-webkit-mask', maskValue);
        item.style.setProperty('mask', maskValue);
        item.style.opacity = 1;

        // 设置背景位置：让渐变背景从左向右移动，产生颜色扫过效果
        // 背景宽度200%，移动范围从0%到-100% 或 0%到100%？这里选择从0%到100%，
        // 即背景向左移动，使得渐变的右侧部分先进入可见区域（因为mask从左向右打开）
        // 您可以根据实际视觉效果调整方向和范围
        const bgPos = partialProgress * 100; // 0% → 100%
        item.style.backgroundPosition = `${bgPos}% 0%`;
      } else {
        // 完全隐藏
        item.classList.remove('fully-visible');
        item.style.setProperty('-webkit-mask', 'linear-gradient(90deg, transparent 0%, transparent 100%)');
        item.style.setProperty('mask', 'linear-gradient(90deg, transparent 0%, transparent 100%)');
        item.style.opacity = 0.5;
        // 背景位置重置
        item.style.backgroundPosition = '0% 0%';
      }
    });
  }

  // --- 4. 滚动事件处理：根据滚动位置计算进度 ---------------------
  function updateOnScroll() {
    const scrollY = window.pageYOffset || document.documentElement.scrollTop;
    const vh = window.innerHeight;

    const rect = section.getBoundingClientRect();
    const sectionTop = scrollY + rect.top;

    const start = sectionTop - vh;
    const end = sectionTop - TRIGGER_DISTANCE;

    let progress = 0;
    if (end > start) {
      progress = (scrollY - start) / (end - start);
    } else {
      if (rect.top <= TRIGGER_DISTANCE && rect.top >= -rect.height) {
        progress = 1;
      }
    }
    progress = Math.max(0, Math.min(1, progress));
    updateItemsByProgress(progress);
  }

  // --- 5. 监听滚动事件（节流）-----------------------------------
  let ticking = false;
  function scrollHandler() {
    if (!ticking) {
      requestAnimationFrame(() => {
        updateOnScroll();
        ticking = false;
      });
      ticking = true;
    }
  }
  window.addEventListener('scroll', scrollHandler);

  // --- 6. 窗口大小变化时重新计算---------------------------------
  window.addEventListener('resize', () => {
    clearTimeout(window._resizeTimer);
    window._resizeTimer = setTimeout(() => {
      updateOnScroll();
    }, 100);
  });

  // --- 7. 初始执行一次 -----------------------------------------
  updateOnScroll();

  // --- 8. 清理（可选）-------------------------------------------
  window.addEventListener('beforeunload', () => {
    window.removeEventListener('scroll', scrollHandler);
  });
}

function boldFirstTwoChars() {
  const elements = document.querySelectorAll('.font2_font');
  
  elements.forEach(el => {
    const text = el.textContent || '';
    if (text.length === 0) return;

    // 取前两个字符，其余保持不变
    const firstTwo = text.slice(0, 2);
    const rest = text.slice(2);

    // 用 span 包裹前两个字符并加粗
    el.innerHTML = `<span style="font-weight: 900;color:#fff">${firstTwo}</span>${rest}`;
  });
}

// 初始页面宽度
let currentWidth = window.innerWidth;
boldFirstTwoChars()
if (currentWidth >= 1024) {
  wheel_display_comparison();
}

// 监听窗口大小变化
window.addEventListener('resize', () => {
  currentWidth = window.innerWidth;
  if (currentWidth >= 1024) {
    wheel_display_comparison();
  }
  boldFirstTwoChars()
});